@file:UseSerializers(UuidSerializer::class)

package it.neckar.lizergy.comments.client

import it.neckar.rest.RestResponse
import it.neckar.uuid.UuidSerializer
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers

@Serializable
sealed interface SaveCommentResponse : RestResponse<Boolean> {

  @Serializable
  @SerialName("good")
  data class Good internal constructor(override val data: Boolean) : SaveCommentResponse, RestResponse.GoodResponse<Boolean>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : SaveCommentResponse, RestResponse.BadResponse<Boolean>

  companion object {
    fun good(): SaveCommentResponse = Good(true)

    fun bad(): SaveCommentResponse = Failed
  }
}
